/* eslint-disable */
import _ from 'lodash';

const getters = {
  isShopAuthenticated: state => state.authenticated,
  shopToken: state => state.shopToken,
  currentShop: state => state.shop,
  shopInfos: state => state.shopInfos,
  currentShopId: state => _.get(state, 'shop.shopId', null),
};

export default getters;
